// extracted by mini-css-extract-plugin
var _1 = "L7KYH6aFU1d_8of3Kx_I";
export { _1 as "mainContentArea" }
